import { useEffect } from "react";
import { getDecodedTokenDetails } from "@/components/Token/TokenService";

export const useCheckUserUM = (setUserUM: (value: boolean) => void) => {
    useEffect(() => {
        (async () => {
            const tokenDetails = await getDecodedTokenDetails();

            if (tokenDetails?.token) {
                try {
                    setUserUM(tokenDetails.WPIDClaim === "70002");
                } catch (error) {
                    console.error("Failed to decode token", error);
                }
            } else {
                console.error("No token found");
            }
        })();
    }, [setUserUM]);
};